import React from 'react';

/**
 * Get initials from a full name
 * @param {string} name - Full name (e.g., "John Doe")
 * @returns {string} Initials (e.g., "JD")
 */
const getInitials = (name) => {
    if (!name) return '?';

    const parts = name.trim().split(' ');
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }

    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

/**
 * Avatar component that displays user picture or initials fallback
 * @param {Object} props
 * @param {string} props.picture - URL of the user's picture
 * @param {string} props.name - User's name for initials fallback
 * @param {number} props.size - Size of the avatar in pixels (default: 32)
 * @param {Object} props.style - Additional inline styles
 */
export default function Avatar({ picture, name, size = 32, style = {} }) {
    const initials = getInitials(name);

    if (picture) {
        return (
            <img
                src={picture}
                alt={name || 'User'}
                style={{
                    width: `${size}px`,
                    height: `${size}px`,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    ...style
                }}
            />
        );
    }

    // Fallback to initials
    return (
        <div
            style={{
                width: `${size}px`,
                height: `${size}px`,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #d4af37, #f4d03f)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: `${size * 0.4}px`,
                fontWeight: 'bold',
                color: '#1a1a1a',
                ...style
            }}
        >
            {initials}
        </div>
    );
}
